/**
 * 常见的错误码
 *
 */

export const ERR_OK = 0;

export const ERR_FUNCTION_NOT_EXIST = 1001;

export const ERR_CALLBACK_ERROR = 1002;

export const ERR_ENV_ERROR = 2001;



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/util/errno.js